// src/pages/Watchlist.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Heading } from "@chakra-ui/react";
import Watchlist from "../components/Watchlist";

const WatchlistPage = () => {
  const navigate = useNavigate();

  const handleTickerClick = (ticker) => {
    navigate(`/ticker/${ticker}`);
  };

  return (
    <Box p={4}>
      <Heading mb={4}>📊 Watchlist</Heading>
      <Watchlist onTickerClick={handleTickerClick} />
    </Box>
  );
};

export default WatchlistPage;
